// extracted by mini-css-extract-plugin
export default {"wrapper":"vOFJbST4H9mAL3Cc19Tc"};